import React, { useRef, useState } from "react";
import DefaultLayout from "app/layouts/DefaultLayout";
import { useNavigate } from "react-router-dom";
import Path from "app/route/Path";
import SegmentedControl from "app/components/commonUI/SegmentedControl";
import ProductGrid from "app/components/Product/ProductGrid";
import ProductGridItem from "app/components/Product/ProductGridItem";
// import MainMenuItem from "app/components/MainMenuItem";
// import CommonConfirmDialog from "app/components/CommonDialog";
// import Path from "app/route/Path";

function Recommend() {
  const navigate = useNavigate();

  const correctionButtonClicked = () => {
    console.log("ButtonClicked22222");
    navigate(Path.salonDetailMenuCorrection);
  };
  const ButtonClicked = () => {
    console.log("ButtonClicked22222");
    // navigate(Path.salonDetailMenuCorrection);
  };
  const rightButtonClicked = () => {
    console.log("ButtonClicked22222");
    navigate(Path.salonDetailsStaff);
  };

  const leftButtonClicked = () => {
    console.log("ButtonClicked22222");
    navigate(Path.salonDetailsBasics);
  };

  return (
    <DefaultLayout
      headerProps={{
        headerClassName: "md:!block",
        pageTitle: "加盟店情報",
      }}
    >
      <p>メニュー</p>

      <button onClick={correctionButtonClicked}>修正</button>
      <button onClick={ButtonClicked}>削除</button>
      <button onClick={rightButtonClicked}>右（スタッフ情報へ）</button>
      <button onClick={leftButtonClicked}>左（基本情報へ）</button>
    </DefaultLayout>
  );
}

export default Recommend;
